import { useEffect, useState } from "react";
import { TitleHeader } from "../../common/components/TitleHeader/TitleHeader";
import { ColumnItem } from "../../common/models/table";
import {
  useGrueMaterialListState,
  useGrueMaterialStore,
} from "./store/GrueStore";
import { ActionsKey } from "../../common/models/Actions";
import { MaterialService } from "./core/_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../common/components/Loader/Loader";
import { CustomDrawer } from "../../common/components/Drawer/CustomDrawer";
import { GrueForm } from "./components/grue/GrueForm";
import {
  useQueryCraneMaterialTypeSelect,
  useQueryMachineMaterialFromSelect,
  useQueryMachineMaterialStateSelect,
} from "./core/_hooks";
import { LFTableV3 } from "../../common/components/LFTable/LFTableV3";
import { getStateTagData } from "../../utilities/StateTag";
import { Tag } from "antd";

export const GruePage = () => {
  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { data: stateOptions, isLoading: isLoadingState } =
    useQueryMachineMaterialStateSelect({}, false);
  const { data: fromOptions, isLoading: isLoadingFrom } =
    useQueryMachineMaterialFromSelect({}, false);
  const { data: typeOptions, isLoading: isLoadingType } =
    useQueryCraneMaterialTypeSelect({}, false);

  const {
    grueMaterialList,
    setGrueMaterialList,
    totalItems,
    actioned,
    setActioned,
  } = useGrueMaterialStore();
  const { pageState, setPageState, resetPageState } =
    useGrueMaterialListState();

  const cols: ColumnItem[] = [
    {
      key: "reference",
      title: "Référence",
      dataIndex: "reference",
      show: true,
      isCanSort: true,
      searchType: "text",
    },
    {
      key: "capacity",
      title: "Capacité (T) ",
      dataIndex: "capacity",
      show: true,
    },
    {
      key: "materialState",
      title: "Etat",
      dataIndex: "materialState",
      show: true,
      nestedKey: "materialState",
      searchType: "select",
      searchOptions: stateOptions,
      isLoading: isLoadingState,
      render: (state: any) => {
        const { label, color } = getStateTagData(state?.id);
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <Tag color={color}>{label}</Tag>
          </div>
        );
      },
    },
    {
      key: "materialFrom",
      title: "Propriétaire",
      dataIndex: "materialFrom",
      show: true,
      searchType: "select",
      nestedKey: "materialFrom",
      searchOptions: fromOptions,
      isLoading: isLoadingFrom,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
    {
      key: "driver",
      title: "Conducteur",
      dataIndex: "driver",
      show: true,
      // searchType: "select",
      nestedKey: "driver",
      // searchOptions: fromOptions,
      isLoading: isLoadingFrom,
      render: (driver: any, record: any) => {
        const name = driver?.fullname ?? record?.comamaDriverName ?? "-";
    
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{name}</span>
          </div>
        );
      },
    },
    {
      key: "craneMaterialType",
      title: "Type",
      dataIndex: "craneMaterialType",
      show: true,
      searchType: "select",
      nestedKey: "craneMaterialType",
      searchOptions: typeOptions,
      isLoading: isLoadingType,
      render: (state: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{state?.name}</span>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    fetchAllMaterialGrue(pageState);
  }, [pageState]);

  useEffect(() => {
    if (!isShowForm) {
      setActioned({ action: "no", data: null });
    }
  }, [isShowForm]);

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "delete") {
      onDeleteHandler(item?.id);
      console.log(item?.id);
    } else {
      console.log(item?.id, action);
      getOne(item?.id, action);
    }
  };

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  const onClickOnAdd = () => {
    onShowAddHandler();
  };

  const getOne = async (id: number, action: any) => {
    try {
      setIsLoading(true);
      const res = await MaterialService.getOneGrueMaterial(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
          },
          action,
        });
      }
      onShowAddHandler();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const onDeleteHandler = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await MaterialService.deleteGrueMaterial(id);
      if (res?.status === HttpStatusCode.NoContent) {
        fetchAllMaterialGrue();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllMaterialGrue = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await MaterialService.getGrueMaterial(params);
      if (res?.status === HttpStatusCode.Ok) {
        setGrueMaterialList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishAction = () => {
    resetPageState();
    onShowAddHandler();
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };
  return (
    <div className="">
      <Loader isLoading={isLoading} />

      <TitleHeader
        title="Matériels de levage"
        isSHowBack
        isEnableAdd
        onClickOnAdd={onClickOnAdd}
      />
      <div className="mt-4">
        {/* Table section  */}
        <div className="">
          <LFTableV3
            columns={cols}
            data={grueMaterialList}
            params={pageState}
            onAction={onActionClick}
            isCanEdit={() => true}
            isCanDelete={() => true}
            onSearch={handleSetParams}
            onSort={handleSetParams}
            onResetSearch={resetPageState}
            pagination={{
              defaultCurrentPage: pageState.page,
              itemsPerPage: pageState?.itemsPerPage,
              totalItems: totalItems,
            }}
            onChangePage={handleSetParams}
          />
        </div>
      </div>

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={onShowAddHandler}
          title={actioned?.action === "update" ? "Modification" : "Nouveau"}
          width={"75%"}
        >
          <GrueForm
            onFinish={onFinishAction}
            {...(actioned?.action === "update"
              ? {
                  initialValue: actioned?.data,
                }
              : {})}
          />
        </CustomDrawer>
      ) : (
        ""
      )}
    </div>
  );
};
